import styled from 'styled-components';

interface IVideoPopupProps {
  $leftPercent: number;
}

export const Container = styled.div`
  width: 100%;
  position: relative;
  overflow: visible;
`;

export const SVGWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: visible;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const VideoPopup = styled.div<IVideoPopupProps>`
  position: absolute;
  left: ${({ $leftPercent }) =>
    `clamp(160px, calc(${$leftPercent}% ), calc(100% - 160px))`};
  bottom: -30%;
  transform: translateX(-50%);
  z-index: 100;
  background: #1a1a1a;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
  pointer-events: all;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #1a1a1a;
  }
`;

/* ── Mobile layout (≤ 767px) ── */

export const MobileList = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 8px 0;
  }
`;

export const MobileEraItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MobileEraRow = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  background: none;
  border: none;
  padding: 4px 0;
  width: 100%;
  text-align: left;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid #4caf50;
    outline-offset: 4px;
    border-radius: 4px;
  }
`;

interface IMobileCircleWrapperProps {
  $isActive: boolean;
}

export const MobileCircleWrapper = styled.div<IMobileCircleWrapperProps>`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 3px solid
    ${({ $isActive }) => ($isActive ? '#4caf50' : 'rgba(255, 255, 255, 0.6)')};
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
  transition: border-color 0.2s ease;
`;

export const MobileCircleImage = styled.div<{ $image?: string }>`
  position: absolute;
  inset: 0;
  background: ${({ $image }) =>
    $image ? `url("${$image}") center / cover no-repeat` : 'transparent'};
`;

export const MobileCircleOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
`;

export const MobileLabel = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: #323232;
  flex: 1;
`;

export const MobileConnectorLine = styled.div`
  width: 3px;
  height: 28px;
  background: #4caf50;
  margin-left: 37px;
`;

export const MobileVideoPanel = styled.div`
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: #1a1a1a;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);
  margin: 8px 0;
`;
